import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '../src/assets/scss/global.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import AboutUs from './pages/about-us';
import Error404 from './pages/error404/error404';
import HomeIndex from './pages/home';
import Services from './component/services/services-item';

const TestPage = React.lazy(() => import('./pages/ajay/index'));
// All Headers
const Header1 = React.lazy(() => import('./layouts/header/Header1'));
const Header2 = React.lazy(() => import('./layouts/header/header2'));
const Header3 = React.lazy(() => import('./layouts/header/header3'));

// All Footers
const FooterStyle01 = React.lazy(
  () => import('./layouts/footer/footer-style-01')
);
const FooterStyle02 = React.lazy(
  () => import('./layouts/footer/footer-style-02')
);
const FooterStyle03 = React.lazy(
  () => import('./layouts/footer/footer-style-03')
);
const BackTop = React.lazy(() => import('./component/back-top'));

// Home

const Blog = React.lazy(() => import('./pages/blog/Blog'));
const BlogGrid = React.lazy(() => import('./pages/blog/blog-grid'));
const BlogSingle = React.lazy(() => import('./pages/blog/blog-details'));
const CaseStudy = React.lazy(() => import('./pages/case-study/case-study'));
const CaseStudySingle = React.lazy(
  () => import('./pages/case-study/case-study-details')
);

const Pricing = React.lazy(() => import('./pages/pricing'));
const Faq = React.lazy(() => import('./pages/faq/faq'));
const ComingSoon = React.lazy(() => import('./pages/coming-soon'));

const PrivacyPolicy = React.lazy(() => import('./pages/privacy-policy'));
const TermsConditions = React.lazy(() => import('./pages/terms-conditions'));

// Pages

const Careers = React.lazy(() => import('./pages/careers'));
const HowWeWork = React.lazy(() => import('./pages/how-we-work'));
const Team = React.lazy(() => import('./pages/team/team'));
const TeamSingle = React.lazy(() => import('./pages/team/team-single'));
const MissionVision = React.lazy(() => import('./pages/mission-vision'));
const OurValue = React.lazy(() => import('./pages/our-value'));
const Service = React.lazy(() => import('./pages/services/services'));

const Industries = React.lazy(() => import('./pages/industries'));
const Industries2 = React.lazy(() => import('./pages/industries/industries-2'));
const Industries3 = React.lazy(() => import('./pages/industries/industries-3'));
const Industries4 = React.lazy(() => import('./pages/industries/industries-4'));

// All Elements
const ElementsActionBox = React.lazy(() => import('./elements/action-box'));
const ElementsAccordion = React.lazy(() => import('./elements/accordion'));
const ElementsButton = React.lazy(() => import('./elements/button'));
const ElementsBlog = React.lazy(() => import('./elements/blog'));
const ElementsClientLogo = React.lazy(() => import('./elements/client-logo'));
const ElementsServices = React.lazy(() => import('./elements/services'));
const ElementsServiceBox = React.lazy(() => import('./elements/service-box'));
const ElementsCategoryBox = React.lazy(() => import('./elements/category-box'));
const ElementsCaseStudy = React.lazy(() => import('./elements/case-study'));
const ElementsCountdown = React.lazy(() => import('./elements/countdown'));
const ElementsCounter = React.lazy(() => import('./elements/counter'));
const ElementsTestimonial = React.lazy(() => import('./elements/testimonial'));
const ElementsInfoBox = React.lazy(() => import('./elements/infobox'));
const ElementsFeatureStep = React.lazy(() => import('./elements/feature-step'));
const ElementsPricingTable = React.lazy(
  () => import('./elements/pricing-table')
);
const ElementsTeam = React.lazy(() => import('./elements/team'));
const ElementsTabs = React.lazy(() => import('./elements/tabs'));
const ElementsImageGallery = React.lazy(
  () => import('./elements/image-gallery')
);
const ResponsiveMenu = React.lazy(() => import('./elements/menu'));
const ElementsFeatureInfo = React.lazy(() => import('./elements/feature-info'));
const ElementsList = React.lazy(() => import('./elements/list'));
const ElementsVideo = React.lazy(() => import('./elements/video'));

const ContactUs = React.lazy(() => import('./pages/contact/contact'));

//Services Menu
const ServicesSingle = React.lazy(
  () => import('./pages/services/services-details')
);
const ServicesCICD = React.lazy(
  () => import('./pages/services/devops/ci-cd')
);
const DevopsAutomation = React.lazy(
  () => import('./pages/services/devops/automation')
);
const ContainerizationOrchestration = React.lazy(
  () => import('./pages/services/devops/containerization-orchestration')
);
const CloudMigration = React.lazy(
  () => import('./pages/services/devops/cloud-migration')
);
const Mlops = React.lazy(
  () => import('./pages/services/devops/mlops')
);

const AjayTestPage = React.lazy(() => import('./pages/ajay/index'));

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <Error404 />, // Optional: for 404 errors
    children: [
      // Optional: for nested routes
      { index: true, element: <HomeIndex /> },
      { path: 'about', element: <AboutUs /> },
      {path:'contact-us', element:<ContactUs />},
      { path: 'service', element: <Service /> },
      {path:'ajay-test', element:<AjayTestPage />},
      //Services
      {path:'ci-cd', element:<ServicesCICD />},
      {path:'devops-automation', element:<DevopsAutomation />},
      {path:'containerization-orchestration', element:<ContainerizationOrchestration />},
      {path:'cloud-migration', element:<CloudMigration />},
      {path:'mlops', element:<Mlops />},
    ],
  },
]);
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// basename="/react/hi-soft"
// "homepage": "https://themes.potenzaglobalsolutions.com/react/hi-soft/"
reportWebVitals();
